<hs-lazy-load-panel [content]="lazyLoadPanelContent" [panelKey]="panelKey">
  <ng-template #lazyLoadPanelContent>
    <hs-no-loaded-or-focused-account
      [content]="selectedAccountDependentContent"
    ></hs-no-loaded-or-focused-account>
  </ng-template>

  <ng-template #selectedAccountDependentContent>
    <ngb-accordion
      [destroyOnHide]="false"
      activeIds="account-notes,details-panel"
    >
      <ngb-panel
        id="details-panel"
        [title]="
          selectedAccounts.length > 1
            ? 'Account Details'
            : 'Account ' + accountId + ' Details'
        "
      >
        <ng-template ngbPanelContent>
          <hs-account-details-grid
            *ngIf="accountId; else multipleAccountSelected"
            [accountSelectionChanged]="accountId"
          ></hs-account-details-grid>
        </ng-template>
      </ngb-panel>
      <ngb-panel title="Data Feeds">
        <ng-template ngbPanelContent>
          <hs-transport-details
            *ngIf="accountId; else multipleAccountSelected"
            [accountSelectionChanged]="accountId"
          ></hs-transport-details>
        </ng-template>
      </ngb-panel>
      <ngb-panel id="account-notes" title="Account Notes">
        <ng-template ngbPanelContent>
          <hs-account-notes-grid
            [accountListSelectionChanged]="selectedAccounts"
          ></hs-account-notes-grid>
        </ng-template>
      </ngb-panel>
      <ngb-panel title="Sleeve Details" *ngIf="showSleeveDetails">
        <ng-template ngbPanelContent>
          <hs-sleeve-details-grid
            *ngIf="accountId; else multipleAccountSelected"
            [accountSelectionChanged]="accountId"
            (showSleeveDetailsEmitter)="hideSleeveDetails($event)"
          ></hs-sleeve-details-grid>
        </ng-template>
      </ngb-panel>
      <ngb-panel title="Aggregates" *ngIf="showAggregateDetails">
        <ng-template ngbPanelContent>
          <hs-aggregate-details-grid
            *ngIf="accountId; else multipleAccountSelected"
            [accountSelectionChanged]="accountId"
            (showAggregateDetailsEmitter)="hideAggregateDetails($event)"
          ></hs-aggregate-details-grid>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </ng-template>

  <div></div>
  <ng-template #multipleAccountSelected>
    <hs-panel-card header="Multiple Accounts Selected">
      <p>
        This section requires a single account to be selected before information
        can be displayed. Select a single account from the Accounts panel to
        continue.
      </p>
    </hs-panel-card>
  </ng-template>
</hs-lazy-load-panel>
